

































import { Component, Prop, Emit } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class Dialog extends Vue {
  @Prop(String)
  contentClass!: boolean;

  @Prop(Boolean)
  value!: boolean;

  @Prop(Boolean)
  closable!: boolean;

  @Prop(Boolean)
  popup!: boolean;

  @Prop(Number)
  width!: number;

  @Prop(Boolean)
  lazy!: boolean;

  @Emit('escape')
  onEscape() {}

  focus() {
    //@ts-ignore
    this.$refs.dialog.$refs.content.focus();
  }
}
